module.exports = __webpack_public_path__ + "8e2cc13a3bd04d5e917578fe61c8911c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ClanWebPro-Book.eot
// module id = 171
// module chunks = 0